export const DECLARANT_ACTIVE_COLUMNS = "declarant_active_columns";
export const DECLARANT_ORDER_COLUMNS = "declarant_order_columns";

export const SIGMA_ACTIVE_COLUMNS = "sigma_active_columns";
export const SIGMA_ORDER_COLUMNS = "sigma_order_columns";

export const CREATED_ACTIVE_COLUMNS = "active_created_columns";
export const CREATED_ORDER_COLUMNS = "created_order_columns";

export const DELETED_ACTIVE_COLUMNS = "deleted_active_columns";
export const DELETED_ORDER_COLUMNS = "deleted_order_columns";

export const DECLARANT_DATA_ACTIVE_COLUMNS = "declarant_data_active_columns";
export const DECLARANT_DATA_ORDER_COLUMNS = "declarant_data_order_columns";

export const BY_CLIENTS_ACTIVE_COLUMNS = "by_clients_active_columns";
export const BY_CLIENT_ORDER_COLUMNS = "by_clients_order_columns";

export const CASHBOX_ACTIVE_COLUMNS = "cashbox_active_columns";
export const CASHBOX_ORDER_COLUMNS = "cashbox_order_columns";

export const CMR_ACTIVE_COLUMNS = "cmr_active_columns";
export const CMR_ORDER_COLUMNS = "cmr_order_columns";

export const LOGISTIC_ACTIVE_COLUMNS = "logistic_active_columns";
export const LOGISTIC_ORDER_COLUMNS = "logistic_order_columns";

export const CONTRACT_ACTIVE_COLUMNS = "contract_active_columns";
export const CONTRACT_ORDER_COLUMNS = "contract_order_columns";

export const FLEET_EXPENSES_ACTIVE_COLUMNS = "fleet_expenses_active_columns";
export const FLEET_EXPENSES_ORDER_COLUMNS = "fleet_expenses_order_columns";
